<template>
  <div @click="toggle" class="headerCheckbox" :class="{'checked': checked}"><i class="heart icon"></i></div>
</template>

<script>

export default {
    data: function() {
        return {
            checked: false
        };
    },
    props: {
        shopId: {
            require: true,
            type: Number
        }
    },
    created: function() {
        this.syncCheckedState();
    },
    methods: {
        toggle: function() {
            var shops = this.selectedShops();
            if (!this.checked && shops.length >= 10) {
                alert('まとめて問い合わせリストに追加できるのは10件までです');
                return;
            }
            this.checked = !this.checked;
            _.remove(shops, function(shopId) {
                return this.shopId === shopId;
            }.bind(this));
            if (this.checked) {
                shops.push(this.shopId);
            }
            this.setShops(shops);
            this.$root.selectedShopCount = shops.length;
        },
        syncCheckedState() {
            this.checked = _.includes(this.selectedShops(), this.shopId);
        }
    },
    watch: {
      '$root.selectedShopCount': function() {
        this.syncCheckedState();
      }
    },
};
</script>
